(() => {
  if (window.wsPromotionalPricesInitialized) return;
  window.wsPromotionalPricesInitialized = true;
  let queued = false;
  const refresh = () => {
    queued = false;
    document.querySelectorAll('[data-ws-sale-price]').forEach(promo => {
      const native = promo.nextElementSibling;
      if (!native?.matches('[data-ws-sale-native]')) return;
      const scope = promo.closest('.card-wrapper') || promo.closest('product-info') || promo.closest('.product');
      const plans = scope ? [...scope.querySelectorAll('input[name="selling_plan"]')] : [];
      const subscribed = plans.some(input => !input.disabled && input.value && input.value !== '0');
      if (promo.hidden !== subscribed) promo.hidden = subscribed;
      if (native.hidden !== !subscribed) native.hidden = !subscribed;
      if (!scope) return;
      const selected = scope.querySelector('form[action*="/cart/add"] input[name="id"]');
      try {
        const variants = JSON.parse(promo.querySelector('[data-ws-sale-variants]').textContent);
        const variant = variants.find(item => item.id === selected?.value) || variants[0];
        if (!variant) return;
        if (promo.dataset.wsVariant !== variant.id) {
          promo.querySelector('[data-ws-regular]').textContent = variant.regular;
          promo.querySelector('[data-ws-current]').textContent = variant.sale;
          promo.dataset.wsVariant = variant.id;
        }
        scope.querySelectorAll('.sls-one-time-price').forEach(holder => {
          let label = holder.querySelector('.ws-sale-option-price');
          if (!label) {
            label = document.createElement('span');
            label.className = 'ws-sale-option-price';
            holder.prepend(label);
          }
          if (label.textContent !== variant.sale) label.textContent = variant.sale;
          holder.dataset.wsSaleOption = 'true';
        });
      } catch {
        // Keep Liquid's server-rendered price if optional variant data is unavailable.
      }
    });
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refresh);
  };
  const start = () => {
    refresh();
    new MutationObserver(schedule).observe(document.body, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked']
    });
    document.addEventListener('change', () => { schedule(); setTimeout(schedule, 180); }, true);
    document.addEventListener('shopify:section:load', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
